module.exports = __webpack_public_path__ + "img/木星.805838ec.svg";